<app-widget [widget-meta]="this.data"
  itemCount="{{ (careerData$ | async)?.allCount }}"
  externalLink="{{( (careerData$ | async)?.baseUrl )}}"
  externalLinkText="All Jobs"
  showHelp="true"
  class="widget-job-postings">
  <career-grid-display [blocks$]="careerData$" (openModal)="openModal($event, jobPostings)"></career-grid-display>

  <ng-template #jobPostings let-modal>
    <div class="modal-header">
      <h4 tabindex="0" ngbAutofocus class="modal-title" id="modal-basic-title">{{modalTitle}}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="col-lg-12">
        <table class="table table-striped">
          <thead>
            <tr class="table-success">
              <th scope="col">Company</th>
              <th scope="col">Job</th>
              <th scope="col">{{dateType}} On</th>
              <th scope="col">Due Date</th>
              <th scope="col">App Status</th>
            </tr>
          </thead>
          <tbody>
            @for (job of jobs; track job) {
              <tr>
                <td scope="row" data-label="Company">
                  {{job.CompanyName}}
                </td>
                <td data-label="Job">
                  <a href="{{job.Url}}" class="link-dark" target="_blank">{{ job.JobTitle }}</a>&nbsp;
                  @if (job.IsNew) {
                    <i class="fas fa-star fa-xs text-warning"></i>
                  }
                  @if (job.IsDueSoon) {
                    <i class="fas fa-bell fa-xs text-primary"></i>
                  }
                  @if (job.IsUpdated) {
                    <i class="fas fa-check-circle fa-xs text-success"></i>
                  }
                </td>
                @if (dateType=='Created') {
                  <td data-label="Added On">
                    {{job.CreatedDate | date:'EEEE, MMMM d'}}
                  </td>
                }
                @if (dateType=='Updated') {
                  <td data-label="Added On">
                    {{job.ModifiedDate | date:'EEEE, MMMM d'}}
               }                  
                <td data-label="Due Date">
                {{job.ApplicationDeadline | date:'EEEE, MMMM d'}}
                </td>
                <td>
                {{job.OciStatusDisplay}}
                </td>
            </tr>
            }
            </tbody>
          </table>
        </div>
      </div>
    </ng-template>
  </app-widget>
